// ======================================================================
// File Name       : serviceRecord
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const SERVICE_RECORD_RECEIVE_LIST = 'SERVICE_RECORD_RECEIVE_LIST';
export const REINITIALIZE_FORM = 'REINITIALIZE_FORM';
export const SAVE_SYSTEM_USAGE_MONTHS = 'SAVE_SYSTEM_USAGE_MONTHS';
export const SERVICE_DOWNLOAD_FORM = 'SERVICE_DOWNLOAD_FORM';
export const SERVICE_MONTH_LIST = 'SERVICE_MONTH_LIST';
export const SERVICE_DOWNLOAD_FORM_MONTH_LIST = 'SERVICE_DOWNLOAD_FORM_MONTH_LIST';
export const SERVICE_EDITING_LIST = 'SERVICE_EDITING_LIST';
